module.exports = __webpack_public_path__ + "src/assets/games/36/BALL0027.jpg";